import { createContext, useContext, useMemo, useState, ReactNode } from "react";

/* Entity page cross-module selection bus (directive §21) — modules are not
   isolated islands. Selecting a chain in the Protocol Network can highlight
   the Chain Distribution row, activate the Related Entities chip, etc.
   Visual behavior itself arrives with the Figma-driven build. */

interface EntitySelection {
  selectedChain: string | null;
  setSelectedChain: (chain: string | null) => void;
  focusedEntityId: string | null;
  setFocusedEntityId: (id: string | null) => void;
}

const Ctx = createContext<EntitySelection | null>(null);

export const EntitySelectionProvider = ({ children }: { children: ReactNode }) => {
  const [selectedChain, setSelectedChain] = useState<string | null>(null);
  const [focusedEntityId, setFocusedEntityId] = useState<string | null>(null);
  const value = useMemo(
    () => ({ selectedChain, setSelectedChain, focusedEntityId, setFocusedEntityId }),
    [selectedChain, focusedEntityId]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useEntitySelection = () => {
  const ctx = useContext(Ctx);
  return ctx ?? {
    selectedChain: null, setSelectedChain: () => {},
    focusedEntityId: null, setFocusedEntityId: () => {},
  };
};
